module.exports = __webpack_public_path__ + "static/media/bg_price_plan_from_30_to_34.be504114.webp";